import { API_DATE_TIME_FORMAT } from '$constants'
import {
  ILeaveRequestDayLine,
  ILeaveRequest as ILeaveRequestModel,
  LeaveRequest,
} from '@loadedhub/core-api-sdk'
import dayjs, { Dayjs } from 'dayjs'

export type {
  ILeaveRequestDayLine,
  FileParameter,
  ILeaveRequestFile,
} from '@loadedhub/core-api-sdk'

export {
  LeaveRequest,
  LeaveRequestUpdateRequest,
  LeaveRequestDayLine,
  LeaveRequestFile,
} from '@loadedhub/core-api-sdk'

export interface ILeaveRequest
  extends Omit<ILeaveRequestModel, 'startDateTime' | 'endDateTime'> {
  startDateTime: Dayjs
  endDateTime: Dayjs
}

export const transformLeaveRequestOnGet = (
  leaveRequest: ILeaveRequestModel
): ILeaveRequest => {
  return {
    ...leaveRequest,
    startDateTime: dayjs(leaveRequest.startDateTime),
    endDateTime: dayjs(leaveRequest.endDateTime),
  }
}

export const transformLeaveRequestOnSave = (
  leaveRequest: ILeaveRequest
): LeaveRequest => {
  return {
    ...leaveRequest,
    startDateTime: leaveRequest.startDateTime.format(API_DATE_TIME_FORMAT),
    endDateTime: leaveRequest.endDateTime.format(API_DATE_TIME_FORMAT),
  } as LeaveRequest
}

/**
 * Calculates the hours requested in a leave request
 * @param dayLines the daylines of a leave request used to calculate the hours
 * @returns the hours requested off in a leave request
 */
export const calculateLeaveRequestTotalHours = (
  dayLines: ILeaveRequestDayLine[] | undefined
) => {
  if (!dayLines) return 0

  return (dayLines || []).reduce(
    (sum, dayLine) => sum + (dayLine.hours ?? 0),
    0
  )
}
